import events from './events';
import prefixer from './prefixer';
import time from './time';
import utils from './utils';

export default {events, prefixer, time, utils};
export {events};
export {prefixer};
export {time};
export {utils};
